export default __webpack_public_path__ + "static/media/gwn36.46261f2c.webp";